/*
 * page entity for state
 * */

import { PageInterface } from '@/types/page/page';

export default class PageEntity {
    values: PageInterface;

    constructor() {
        this.values = {
            moduleName: '',
            title: '',
            titleAdd: '',
            titleEdit: '',
            table: {},
            pageCurrent: 1,
            pageAmountItems: 50,
            sort: {},
            filter: '',
            filterAdditional: '',
            filterPreview: '',
            filterModel: {},
            filterValues: {},
            filterHandlers: {},
        };
    }

    setModuleName(title: string) {
        this.values.moduleName = title;
    }

    setTitle(title: string) {
        this.values.title = title;
    }

    setTitleAdd(title: string) {
        this.values.titleAdd = title;
    }

    setTitleEdit(title: string) {
        this.values.titleEdit = title;
    }
}
